package horcrux.frontend.common.views.feedbackform

import horcrux.common.api.dtos.types.UserFeedback
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.ShowDialogState
import horcrux.frontend.common.State
import horcrux.frontend.common.close
import horcrux.frontend.common.get
import mui.material.Button
import mui.material.Dialog
import mui.material.DialogActions
import mui.material.DialogContent
import mui.material.DialogContentText
import react.FC
import react.Props
import react.router.useNavigate

external interface FeedbackFormDialogProps : Props {
    var showDialogState: ShowDialogState
    var globalAppState: GlobalAppState
}

typealias UserFeedbackMaybeState = State<UserFeedback?>

val FEEDBACK_MESSAGE =
    "Let us know what you think! Have a question? Want to request a new feature? Think Grok might be useful at your company? Contact us below."

val FeedbackFormDialog = FC<FeedbackFormDialogProps> { props ->
    val userFeedbackMaybeState = State<UserFeedback?>(null)
    val navigate = useNavigate()

    fun closeDialog() {
        userFeedbackMaybeState.set(null)
        props.showDialogState.close()
    }

    Dialog {
        this.title = "Tell Us What You Think"
        this.open = props.showDialogState.get()
        this.maxWidth = "md"
        this.fullWidth = true
        DialogContent {
            DialogContentText {
                +FEEDBACK_MESSAGE
            }
            FeedbackForm {
                this.userFeedbackMaybeState = userFeedbackMaybeState
                this.feedbackType = FeedbackType.FEEDBACK
            }
        }
        DialogActions {
            Button {
                +"Cancel"
                this.onClick = { closeDialog() }
            }
            Button {
                +"Submit"
                this.onClick = {
                    userFeedbackMaybeState.submitIfValid(navigate, props.globalAppState) { closeDialog() }
                }
            }
        }
    }
}
